import md5 from 'md5'

export type Metrics = {
    message: string
    read_time: Pair
    speak_time: Pair
    paragraphs: Pair
    sentences: Pair
    words: Pair
    syllabes: Pair
    graphemes: Pair
    dirty: boolean
}

export type Pair = {
    name: string
    value: string
}

type MetricsResponse = {
    metrics: Metrics
}

class MetricsClient {

    private cache : Map<string, Metrics>
  
    private url : string = "https://api.softcatala.org/text-metrics-service/v1/metrics"

    constructor() {
      this.cache = new Map()
    }
  
    public async getMetrics(text: string) {
      
        const hash = md5(text)
        if (this.cache.has(hash)) {
            return Promise.resolve(this.cache.get(hash))
        }

        try {
            const raw = await fetch(this.url, {
                method: 'POST',
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                mode: "cors" as RequestMode,
                body: new URLSearchParams({ 'text': text })
            });

            const response = (await raw.json()) as MetricsResponse;

            this.cache.set(hash, response.metrics)

            return response.metrics;
        } catch (e) {
            return null;
        }
    }
}

const metricsClient = new MetricsClient()

export const getMetrics = async(text:string, callBack: (m : Metrics|null|undefined) => void) => {
    const metrics = await metricsClient.getMetrics(text)
    
    callBack(metrics)
}